module.exports = __webpack_public_path__ + "4afc379c27e99258eda468f4e4c901e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/footer/SIAS_stacked_rev_web.png
// module id = 858
// module chunks = 0